<template>
  <div class="WarehousesTableItem">
    <ul
      class="app-table-dropdown__list app-table-dropdown__row-body-default-item"
    >
      <li class="WarehousesTableItem__list-item app-table-dropdown__list-item">
        <span
          class="WarehousesTableItem__list-title app-table-dropdown__list-title"
        >
          Регион
        </span>
        <p class="app-table-dropdown__list-text">
          {{ response.region || 'н/д' }}
        </p>
      </li>
      <li class="WarehousesTableItem__list-item app-table-dropdown__list-item">
        <span
          class="WarehousesTableItem__list-title app-table-dropdown__list-title"
        >
          Координаты
        </span>
        <p class="app-table-dropdown__list-text">
          {{ response.location || 'н/д' }}
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'WarehousesTableItem',
  props: {
    response: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.WarehousesTableItem {
  display: flex;
  width: 100%;

  &__list-item {
    @include media-xxs() {
      flex-direction: column;
    }
  }

  &__list-title {
    flex-grow: 1;
    flex-shrink: 0;
    width: 100px;
    max-width: 277px;
  }
}
</style>
